export default __webpack_public_path__ + "static/media/calculator_icon_hover.c43326af.svg";